import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';
import IconCity from '@svg/icon-city.svg';
import IconTime from '@svg/icon-time.svg';
import IconEducation from '@svg/icon-education.svg';
import styles from './VacancyMeta.module.scss';

const VacancyMeta = ({
  city,
  employmentType,
  educationLevel,
  publishFrom,
  publishTo,
}) => {
  const { t } = useTranslation('vacancy');

  return (
    <div className={styles.container}>
      <dl className={styles.properties}>
        {city && (
          <div className={styles.item}>
            <dt>
              <IconCity className={styles.icon} title={t('location')} />
            </dt>
            <dd>{city}</dd>
          </div>
        )}

        {employmentType && (
          <div className={styles.item}>
            <dt>
              <IconTime className={styles.icon} title={t('numberOfHours')} />
            </dt>
            <dd>{employmentType}</dd>
          </div>
        )}

        {educationLevel && (
          <div className={styles.item}>
            <dt>
              <IconEducation className={styles.icon} title={t('education')} />
            </dt>
            <dd>{educationLevel}</dd>
          </div>
        )}
      </dl>

      <div className={styles.meta}>
        <div>
          {t('publishFrom')}: {dayjs(publishFrom).format('DD-MM-YYYY')}
        </div>

        {publishTo && (
          <div>
            {t('publishTo')}: {dayjs(publishTo).format('DD-MM-YYYY')}
          </div>
        )}
      </div>
    </div>
  );
};

export default VacancyMeta;

VacancyMeta.propTypes = {
  city: PropTypes.string,
  employmentType: PropTypes.string,
  educationLevel: PropTypes.string,
  publishFrom: PropTypes.string,
  publishTo: PropTypes.string,
};
